import { formatInteger } from '../_shared/ululeStats'
import type { Collection, PresaleWording } from './collections'

const PRESALE_NOUNS: Record<PresaleWording, { singular: string; plural: string }> = {
  presale: { singular: 'prévente', plural: 'préventes' },
  contribution: { singular: 'contribution', plural: 'contributions' },
  contributor: { singular: 'contributeur·ice', plural: 'contributeur·ices' },
}

/** The count and its accessible label use the same resolved unit, including irregular plurals. */
export function topCollectionValue(collection: Collection): { value: string; valueLabel?: string } {
  if (!collection.isPresale) {
    return { value: `${formatInteger(collection.amountEur)} €` }
  }

  const noun =
    (collection.presaleWording === 'presale' ? collection.presaleNoun : undefined) ??
    PRESALE_NOUNS[collection.presaleWording]
  const counted = collection.presaleCount > 1 ? noun.plural : noun.singular

  return {
    value: `${formatInteger(collection.presaleCount)} ${counted}`,
    valueLabel: `${noun.plural.charAt(0).toLocaleUpperCase('fr')}${noun.plural.slice(1)} :`,
  }
}
